import { NoTranslate } from '../no-translate/no-translate'
import { PageHeader } from '@pushly/aqe/lib/components'
import React, { ComponentProps } from 'react'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../services'
import { ExposeUserObject } from '../app-message-builder/model-extensions'
import { Flex, Typography } from 'antd'
import { VERTICAL_WELL_GAP } from '@pushly/aqe'

// Page Header
export type DetailsViewPageHeaderProps<T> = {
    title: string
    resource: T & { id?: number | string; creator?: ExposeUserObject; createdByUserName?: string }
    buildSubOptions: () => React.ReactNode
    addOnAfter?: () => React.ReactNode
    className?: string
    action?: ComponentProps<typeof PageHeader>['action']
}

export const DetailsViewPageHeader = <T extends {} = any>(props: DetailsViewPageHeaderProps<T>) => {
    const appSvc = useService(AppService)
    return (
        <Flex vertical gap={VERTICAL_WELL_GAP}>
            <PageHeader
                title={<NoTranslate>{props.title}</NoTranslate>}
                onTitleSet={appSvc.customizeTabTitle}
                append={
                    <span>
                        #{props.resource?.id ?? 0}
                        <span>
                            {' '}
                            | Created by{' '}
                            <NoTranslate>
                                {props.resource.creator?.name ?? props.resource.createdByUserName ?? 'Unknown User'}
                            </NoTranslate>
                            &nbsp;
                        </span>
                        {props.buildSubOptions()}
                    </span>
                }
                action={props.action}
            />
            {props.addOnAfter && props.addOnAfter()}
        </Flex>
    )
}
